// TelcoTrack — single toast service. app-toast-host is the only renderer.

import { Injectable, OnDestroy } from '@angular/core';
import { ToastQueue } from './toast-queue';

export { TT_TOAST_DISMISS_MS, TT_TOAST_MOTION_MS } from './toast-queue';
export type { ToastItem, ToastVariant } from './toast-queue';

@Injectable({
  providedIn: 'root',
})
export class ToastService implements OnDestroy {
  private readonly queue = new ToastQueue();
  readonly items$ = this.queue.items$;

  ngOnDestroy(): void {
    this.queue.destroy();
  }

  showSuccess(message: string): void {
    this.queue.showSuccess(message);
  }

  showError(message: string): void {
    this.queue.showError(message);
  }

  showInfo(message: string): void {
    this.queue.showInfo(message);
  }

  dismiss(id: number): void {
    this.queue.dismiss(id);
  }

  /** Clear the queue without leave animation (e.g. map mode cancelled). */
  dismissAll(): void {
    this.queue.dismissAll();
  }
}
